import React, { useState, useEffect, useCallback, useRef } from 'react'

// Deps
import { redirect } from 'controllers/navigator'

// Partials
import Btn from 'views/shared/partials/btn'
import Link from 'views/shared/partials/link'
import Loader from 'views/shared/partials/loader'
import Pricebox from 'views/shared/partials/pricebox'
// import ConversionInfo from 'views/shared/partials/conversion-info'
import OrderStatus from 'views/shared/partials/order-status'
import { Table, TR, TD } from 'views/shared/partials/table'

// Utils
import { openModal } from 'utils/modals'

// Functions
import formatDate from 'functions/format-date'
import isExact from 'functions/is-exact'
// import getCurrencySymbol from 'functions/get-currency-symbol'

// Sections
import Breadcrumbs from 'views/admin/sections/breadcrumbs'
import OrderList from 'views/admin/sections/order-list'

// Services
import orderServices from 'services/order'

const OrderPlanDetail = (props) => {
	const updateOrderList = useRef();

	const planID = props.match.params.id;
	const defaultOrderQuery = {
		page: 1,
		sort_by: 'created_at',
		order_plan_id: planID,
	}

	const [periodLoading, setPeriodLoading] = useState(false)
	const [data, setData] = useState(false);
	const [orderQuery, setOrderQuery] = useState(defaultOrderQuery)

	const getData = useCallback(() => {
		setData(false);

		orderServices.getOrderPlan(planID).then((payload) => {
			setData(payload);
		});
	}, [planID]);

	const deleteOrderPlan = () => {
		openModal(
			'confirm',
			{
				message: 'Ödeme planını iptal etmek istediğinizden emin misiniz?',
				onConfirm: () => {
					orderServices.deleteOrderPlan(data.id).then(() => {
						redirect('orderPlans');
					}).catch(() => {})
				}
			}
		)
	}

	const createPeriodToOrderPlan = (installment) => {
		openModal(
			'confirm',
			{
				message: 'Ödeme talebini şimdi oluşturmak istediğinizden emin misiniz?',
				onConfirm: () => {
					setPeriodLoading(installment.id)
					orderServices.createPeriodToOrderPlan(data.id).then(() => {
						getData();
						updateOrderList.current();
					}).catch(() => {})
						.finally(() => setPeriodLoading(false))
				}
			}
		)
	}

	const paginateOrders = (page) => {
		setOrderQuery({...defaultOrderQuery, page: page});
	}

	useEffect(() => {
		getData();

		if (!isExact(orderQuery !== defaultOrderQuery)) {
			setOrderQuery(defaultOrderQuery);
		}

		if(updateOrderList.current) {
			updateOrderList.current();
		}
	}, [planID, getData]) // eslint-disable-line react-hooks/exhaustive-deps

	console.log(data)

	return (
		<main className="page order-detail">
			<Breadcrumbs
				midSections={[
					{href: 'orderPlans'}
				]} />
			<section className="portlet section detail-info loader-container">
				<Loader loading={!data} />
				{data &&
					<React.Fragment>
						<div className="portlet-header">
							<h1 className="portlet-title">
								<span>{(data.client.invoice_type === 2 && data.client.company_name) ? data.client.company_name : (data.client.executive_name + ' ' + data.client.executive_surname)}</span>
								{(data.client.invoice_type === 2 && data.client.company_name) &&
									<span className="title-subtitle">{data.client.executive_name} {data.client.executive_surname}</span>
								}
							</h1>

							<div className="header-controls">
								<Btn
									white small wide
									onClick={() => { openModal('update-order', {
										orderCode: data.id,
										orderPlan: data,
										periods: data.periods,
										onSuccess: getData
									}); }}
									icon="edit">
									Bilgileri Düzenle
								</Btn>
								<Btn
									small wide error outline
									onClick={deleteOrderPlan}
									icon="trash">
									İptal Et
								</Btn>
							</div>
						</div>

						<div className="portlet-section">
							<div className="portlet-infobar">
								<div className="grid-container">
									<div className="row">
										<div className="col x3">
											<div className="infobar-section">
												<strong className="section-title">Ödeme Tutarı</strong>
												<span className="section-data">
													<Pricebox
														showCode big
														price={data.total_amount}
														currency={data.price_type.currency_symbol} />
												</span>
											</div>
										</div>
										<div className="col x3">
											<div className="infobar-section">
												<strong className="section-title">Kalan Bakiye</strong>
												<span className="section-data">
													<p>
														<Pricebox
															showCode big
															price={data.remaining_amount}
															currency={data.price_type.currency_symbol} />
													</p>
													{(data.remaining_amount && data.remaining_amount !== "0" && data.currency_exchange_type_id > 0 && data.currency_exchange_rate.rate) &&
														<p>
															<span className="label dark text-regular">
																<Pricebox
																	monochrome
																	price={(data.remaining_amount * data.currency_exchange_rate.rate)} />
															</span>
														</p>
													}
												</span>
											</div>
										</div>
										<div className="col x3">
											<div className="infobar-section">
												<strong className="section-title">Ödenen Bakiye</strong>
												<span className="section-data">
													<p>
														<Pricebox
															big
															price={data.payment_amount}
															currency={data.price_type.currency_symbol} />
													</p>
													{(data.payment_amount > 0 && data.payment_amount !== "0" && data.currency_exchange_type_id > 0 && data.currency_exchange_rate.rate) &&
														<p>
															<span className="label dark text-regular">
																<Pricebox
																	monochrome
																	price={data.currency_exchange_amount} />
															</span>
														</p>
													}
												</span>
											</div>
										</div>
										<div className="col x3">
											<div className="infobar-section">
												<strong className="section-title">İade Edilen Bakiye</strong>
												<span className="section-data">
													<p>
														<Pricebox
															big
															price={data.refund_amount}
															currency={data.price_type.currency_symbol} />
													</p>
													{(data.refund_amount > 0 && data.refund_amount !== "0" && data.currency_exchange_type_id > 0 && data.currency_exchange_rate.rate) &&
														<p>
															<span className="label dark text-regular">
																<Pricebox
																	monochrome
																	price={(data.refund_amount * data.currency_exchange_rate.rate)} />
															</span>
														</p>
													}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="portlet-section bottom border-top">
							<div className="portlet-infobar horizontal">
								<div className="grid-container">
									<div className="row">
										<div className="col x8">
											<strong className="infobar-title">Ödeme Bilgileri</strong>
											<div className="row">
												<div className="col x6">
													<div className="infobar-section">
														<strong className="section-title">İşletme Grubu</strong>
														<span className="section-data">
															{data.group.name}
														</span>
													</div>

													<div className="infobar-section">
														<strong className="section-title">Ödeme Oluşturan</strong>
														<span className="section-data">
															{data.account.name} {data.account.surname}
														</span>
													</div>
												</div>
												<div className="col x6">
													<div className="infobar-section">
														<strong className="section-title">Sipariş Tutarı</strong>
														<span className="section-data">
															<Pricebox
																showCode monochrome
																price={data.total_amount}
																currency={data.price_type.currency_symbol} />
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">Sipariş Durumu</strong>
														<span className="section-data">
															<OrderStatus label status={data.status} />
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">Oluşturulma Tarihi</strong>
														<span className="section-data">
															{formatDate(data.created_at)}
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">Ödeme Vadesi</strong>
														<span className="section-data">
															{formatDate(data.due_date)}
														</span>
													</div>
												</div>
											</div>

											<strong className="infobar-title">Ödeme Açıklaması</strong>
											<div className="row">
												<div className="col">
													<div className="infobar-section">
														<div className="section-data">
															{data.description}
														</div>
													</div>
												</div>
											</div>

											<strong className="infobar-title">Müşteri Bilgileri</strong>
											<div className="row">
												<div className="col x6">
													<div className="infobar-section">
														<strong className="section-title">Müşteri Tipi</strong>
														<span className="section-data">
															{data.client.invoice_type === 1 ?
																<label className="label dark">
																	Bireysel
																</label>
																:
																<label className="label">
																	Kurumsal
																</label>
															}
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">{data.client.invoice_type === 2 ? 'Yetkili' : 'Müşteri'} Adı Soyadı</strong>
														<span className="section-data">
															{data.client.executive_name} {data.client.executive_surname}
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">Müşteri Kodu #:</strong>
														<span className="section-data">
															{data.client.client_code}
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">Cep Telefonu</strong>
														<span className="section-data">
															{data.client.phone_number}
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">E-Posta Adresi</strong>
														<span className="section-data">
															{data.client.email}
														</span>
													</div>
												</div>
												<div className="col x6">
													<div className="infobar-section">
														<strong className="section-title">Firma Kısa Adı</strong>
														<span className="section-data">
															<Link href="clientDetail" className="link" params={{id: data.client.client_code}}>{data.client.company_name ? data.client.company_name : '-'}</Link>
														</span>
													</div>
													{data.client.invoice_type === 2 ?
														<React.Fragment>
															<div className="infobar-section">
																<strong className="section-title">Vergi Numarası</strong>
																<span className="section-data">
																	{data.client.tax_number ? data.client.tax_number : '-'}
																</span>
															</div>
															<div className="infobar-section">
																<strong className="section-title">Vergi Dairesi</strong>
																<span className="section-data">
																	{data.client.tax_office ? data.client.tax_office : '-'}
																</span>
															</div>
															<div className="infobar-section">
																<strong className="section-title">Vergi Ünvanı</strong>
																<span className="section-data">
																	{data.client.invoice_name ? data.client.invoice_name : '-'}
																</span>
															</div>
														</React.Fragment>:
														<React.Fragment>
															<div className="infobar-section">
																<strong className="section-title">TC Kimlik No</strong>
																<span className="section-data">
																	{data.client.identity_number ? data.client.identity_number : '-'}
																</span>
															</div>
														</React.Fragment>
													}

													<div className="infobar-section">
														<strong className="section-title">Fatura Adresi</strong>
														<span className="section-data">
															{data.client.invoice_address ? data.client.invoice_address : '-'}
														</span>
													</div>

													<div className="infobar-section">
														<strong className="section-title">Serbest Ödeme Özelliği</strong>
														<span className="section-data">
															{data.client.custom_order ? 'Aktif' : 'Deaktif'}
														</span>
													</div>
												</div>
											</div>
										</div>
										{<div className="col x4">
											<div className="portlet">
												<div className="portlet-header">
													<strong className="portlet-title">Ödeme Takvimi</strong>
												</div>
												<div className="portlet-section bottom">
													<Table
														emptyMessage="Ödeme takvimi boş">
														{data.periods.map((installment, nth) => (
															<TR key={nth}>
																<TD>
																	<p>
																		<strong>{nth + 1}. Dönem</strong> - <span className="table-subtitle">
																			{formatDate(installment.date, 'dd MMMM yyyy')}
																		</span>
																	</p>
																	<p>
																		<Pricebox price={installment.price} currency={data.price_type.currency_symbol} />
																	</p>
																</TD>
																<TD>
																	{(data.order_count >= nth+1) ?
																		<React.Fragment>
																			{(data.order_count_done >= nth + 1) ?
																				<span className="label success">Ödendi</span>
																				:
																				<span className="label warning">Aktif</span>
																			}
																		</React.Fragment>
																		:
																		<React.Fragment>
																			{(data.order_count === nth) ?
																				<Btn
																					white small text-small
																					loading={periodLoading === installment.id}
																					disabled={periodLoading === installment.id}
																					className="small-icon-pre"
																					icon="payment"
																					onClick={() => createPeriodToOrderPlan(installment)}>
																					Şimdi Oluştur
																				</Btn>
																				:
																				<span className="label">Beklemede</span>
																			}
																		</React.Fragment>
																	}
																</TD>
															</TR>
														))}
													</Table>
												</div>
											</div>
										</div>}
									</div>
								</div>
							</div>
						</div>
					</React.Fragment>
				}
			</section>

			<OrderList
				update={func => updateOrderList.current = func}
				orderPlanID={planID}
				onPaginate={paginateOrders}
				query={orderQuery} />
		</main>
	)
}

export default OrderPlanDetail
